module.exports = (el) => {
    if (el) {
        const rect = el.getBoundingClientRect();
        return (
            // uncomment this to get this to return true when the entire element is visible
            // rect.top >= 0 &&
            // rect.left >= 0 &&
            // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }
    return false;
};



// WEBPACK FOOTER //
// ./app/lib/ui/isElementVisible.js